(function installLahziAuthRuntime(global) {
  'use strict';

  if (global.LahziAuth) return;
  let state = 'unknown';
  let refreshPromise = null;
  let bootstrapPromise = null;
  let redirected = false;
  const runtime = global.LahziRuntime;
  const channel = runtime?.createChannel('lahzi-auth') || null;

  function setState(next, detail = {}) {
    state = next;
    global.dispatchEvent(new CustomEvent('lahzi:auth-state', { detail: { state: next, ...detail } }));
  }

  async function refresh() {
    if (refreshPromise) return refreshPromise;
    refreshPromise = (async () => {
      setState('refreshing');
      try {
        const response = await fetch('/api/auth/refresh', {
          method: 'POST', credentials: 'same-origin', cache: 'no-store',
          headers: { 'Content-Type': 'application/json' }, body: '{}',
        });
        if (response.ok) { setState('authenticated'); return true; }
        if (response.status === 401 || response.status === 403) { setState('unauthenticated'); return false; }
        setState('unavailable', { status: response.status });
        return null;
      } catch (error) {
        setState('unavailable', { error: error?.message || 'network' });
        return null;
      } finally { refreshPromise = null; }
    })();
    return refreshPromise;
  }

  async function verifySession() {
    let response;
    try {
      response = await fetch('/api/auth/workspaces', { credentials: 'same-origin', cache: 'no-store' });
    } catch (error) {
      setState('unavailable', { error: error?.message || 'network' });
      return { ok: false, temporary: true };
    }
    if (response.status === 401) {
      const refreshed = await refresh();
      if (refreshed === true) {
        response = await fetch('/api/auth/workspaces', { credentials: 'same-origin', cache: 'no-store' });
      } else return { ok: false, authenticated: false, temporary: refreshed === null };
    }
    if (!response.ok) {
      setState(response.status === 401 || response.status === 403 ? 'unauthenticated' : 'unavailable', { status: response.status });
      return { ok: false, authenticated: false, status: response.status };
    }
    const data = await response.json();
    setState('authenticated');
    return { ok: true, authenticated: true, data };
  }

  function bootstrap() {
    if (!bootstrapPromise) bootstrapPromise = verifySession();
    return bootstrapPromise;
  }

  function redirectToLogin() {
    if (redirected || location.pathname === '/admin/login') return;
    redirected = true;
    location.replace('/admin/login');
  }

  channel?.addEventListener('message', event => {
    if (event.data?.type !== 'logged_out') return;
    setState('unauthenticated');
    if (location.pathname !== '/admin/login') location.replace('/admin/login?logged_out=1');
  });

  global.LahziAuth = Object.freeze({
    bootstrap, verifySession, refresh, redirectToLogin,
    broadcastLogout: () => channel?.postMessage({ type: 'logged_out' }),
    getState: () => state,
    resetBootstrap: () => { bootstrapPromise = null; },
  });
})(window);
